import React from "react";
import { Box, Typography } from "@mui/material";

const Videodetailheader = () => {
  return (
    <>
      <Box
        sx={{
          display: "flex",
          background: "#fff",
          color: "#fff",
          height: "45px",
          width: "100%",
        }}
      >
        <Typography
          sx={{
            width: "70px",
            display: "flex",
            color: "#fff",
            alignItems: "center",
            justifyContent: "center",
            borderLeft: "1px solid #e0e0ef",
            borderTop: "1px solid #e0e0ef",
            borderBottom: "1px solid #e0e0ef",
            height: 44,
            background: "#A10303",
          }}
        >
          No
        </Typography>
        <Typography
          sx={{
            width: "200px",
            borderLeft: "1px solid #e0e0ef",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            borderBottom: "1px solid #e0e0ef",
            borderTop: "1px solid #e0e0ef",
            // paddingLeft: 3,
            height: 44,
            color: "#fff",
            background: "#A10303",
          }}
        >
          Chapter Name
        </Typography>
        <Typography
          sx={{
            width: "400px",
            borderLeft: "1px solid #e0e0ef",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            borderBottom: "1px solid #e0e0ef",
            borderTop: "1px solid #e0e0ef",
            // paddingLeft: 3,
            height: 44,
            color: "#fff",
            background: "#A10303",
          }}
        >
          Chapter Description
        </Typography>
        <Typography
          sx={{
            width: "200px",
            borderLeft: "1px solid #e0e0ef",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            borderBottom: "1px solid #e0e0ef",
            borderTop: "1px solid #e0e0ef",
            // paddingLeft: 3,
            height: 44,
            color: "#fff",
            background: "#A10303",
          }}
        >
          Video Name
        </Typography>
        <Typography
          sx={{
            width: "180px",
            borderLeft: "1px solid #e0e0ef",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            borderBottom: "1px solid #e0e0ef",
            borderTop: "1px solid #e0e0ef",
            // paddingLeft: 3,
            height: 44,
            color: "#fff",
            background: "#A10303",
          }}
        >
          Video Link
        </Typography>
      </Box>
    </>
  );
};

export default Videodetailheader;
